export default {
  computed: {
    dataBarCollection() {
      if (this.data.length) {
        return {
          labels: this.getLabels(),
          datasets: this.getDataSets()
        };
      }

      return {};
    }
  },
  methods: {
    average(nums) {
      return nums.reduce((a, b) => (a + b)) / nums.length;
    },
    getDataSets() {
      return [
        {
          label: this.$t('feed.audit.likesAndReposts.body.likes'),
          backgroundColor: "#4c75a3",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data[0].likes.graph_data.map(item => item[1]),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.audit.likesAndReposts.body.reposts'),
          backgroundColor: "#c147ec",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data[1].reposts.graph_data.map(item => item[1]),
          showLabel: this.showLabel,
        },
        {
          label: this.$t('feed.audit.likesAndReposts.body.comments'),
          backgroundColor: "#fb614d",
          borderColor: "rgba(0, 0, 0, 0)",
          data: this.data[2].comments.graph_data.map(item => item[1]),
          showLabel: this.showLabel,
        }
      ];
    },
    getLabels() {
      return this.data[0].likes.graph_data.map(item => {
        let dateSeparator = "-";

        if (item[0].includes(dateSeparator)) {
          let dateArr = item[0].split('-');
          let month = parseInt(dateArr[1]) - 1;

          return [item[0].slice(-2), this.month[month]];
        }

        return item[0];
      });
    }
  },
  data() {
    return {
      month: this.$t('feed.audit.likesAndReposts.body.month'),
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)"
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            boxWidth: 7,
            usePointStyle: true
          }
        },
        plugins: {
          datalabels: {
            anchor: "end",
            color: "#000000",
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: function(value, ctx) {
              if (value === 0) {
                return "";
              }

              return value;
            },
            align: (ctx) => {
              if (ctx.dataset.data.length) {
                const index = ctx.dataIndex;
                const value = ctx.dataset.data[index];
                const max = ctx.chart.scales['y-axis-0'].max;
                const step = Math.round(max / ctx.dataset.data.length);

                return value >= (max - step) ? "bottom" : "top";
              }
            },
            font: {
              size: 14,
              family: "Roboto",
            },
          },
          clamp: true,
          clip: true,
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
